module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0Mi4zIDQ0MGExNiAxNiAwIDAgMS0xMC44IDQuMkg2NzUuOHY0ODBhMzIgMzIgMCAwIDEtMzIgMzJoLTI1NmEzMiAzMiAwIDAgMS0zMi0zMnYtNDgwSDIwMC4yYTE2IDE2IDAgMCAxLTExLjgtMjYuOGwzMTUuNi0zNDQuM2ExNiAxNiAwIDAgMSAyMi42LTFsMSAxIDMxNS42IDM0NC4zYTE2IDE2IDAgMCAxLTEgMjIuNnoiIGZpbGw9IiMwIiBwLWlkPSIzMzQ4Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-up-filled.svg
// module id = kW5O
// module chunks = 73